import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/auth/LoginForm';
import RegisterForm from '../components/auth/RegisterForm';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';

type AuthFormType = 'login' | 'register' | 'forgot-password';

const Login: React.FC = () => {
  const [activeForm, setActiveForm] = useState<AuthFormType>('login');
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the return URL from location state or default to home
  const returnUrl = location.state?.returnUrl || '/';
  
  // If user is already logged in, redirect to the return URL
  React.useEffect(() => {
    if (user) {
      navigate(returnUrl, { replace: true });
    }
  }, [user, navigate, returnUrl]);
  
  const handleSwitchForm = (formType: AuthFormType) => {
    setActiveForm(formType);
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <img 
            src="https://pub-b889e285347e41b093edf65c2f3ff7c1.r2.dev/naiaweblogo.svg" 
            alt="Naia" 
            className="h-12 mx-auto mb-6" 
          />
          
          <h2 className="text-3xl font-extrabold text-white mb-2">
            {activeForm === 'login' && 'Welcome back'}
            {activeForm === 'register' && 'Create your account'}
            {activeForm === 'forgot-password' && 'Reset your password'}
          </h2>
          
          <p className="text-gray-400 max-w-sm mx-auto">
            {activeForm === 'login' && 'Sign in to access your library, playlists, and favorites.'}
            {activeForm === 'register' && 'Join Naia to discover and enjoy AI-generated music.'}
            {activeForm === 'forgot-password' && 'Enter your email and we\'ll send you a reset link.'}
          </p>
        </div>
        
        <div className="bg-gray-900 rounded-xl shadow-xl p-8 border border-gray-800">
          {activeForm === 'login' && (
            <LoginForm
              onSwitchToRegister={() => handleSwitchForm('register')}
              onSwitchToForgotPassword={() => handleSwitchForm('forgot-password')}
            />
          )}
          
          {activeForm === 'register' && (
            <RegisterForm
              onSwitchToLogin={() => handleSwitchForm('login')}
            />
          )}
          
          {activeForm === 'forgot-password' && (
            <ForgotPasswordForm
              onSwitchToLogin={() => handleSwitchForm('login')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
